/**
 * Accessors for the `metadata` bag on an activity log entry.
 *
 * `ApiActivityLogSchema` used to carry `approvedScopeBudget`, `tasksStarted`,
 * `tasksCompleted` and `tasksForRework` as top-level optional numbers. They moved into
 * the open-ended `metadata` object so new event kinds can add their own fields without
 * widening the schema for every consumer.
 *
 * The values are therefore `unknown` at the type level, and every consumer needs the
 * same narrowing. It lives here, next to the schema that owns the shape, so renovator
 * and kaiPro read it the same way rather than each keeping a private copy.
 */

export interface ActivityLogMetadataCarrier {
  metadata?: Record<string, unknown>;
}

/** Returns the metadata value at `key` when it is a number, otherwise undefined. */
export const getActivityLogMetadataNumber = (
  entry: ActivityLogMetadataCarrier,
  key: string,
): number | undefined => {
  const value = entry.metadata?.[key];
  return typeof value === 'number' ? value : undefined;
};
